import type { RotasDoModulo } from '@/app/rotas';

import { PolicyDetailPage } from './PolicyDetailPage';
import { PoliciesPage } from './PoliciesPage';
import { BankGuaranteesPage, CommissionsPage } from './PortfolioPages';

/**
 * Carteira: apolices, fiancas bancarias e comissoes. O detalhe da apolice (P-APO-1)
 * fica fora do menu, com o mesmo componente para a apolice e a fianca.
 */
export const rotas: RotasDoModulo = {
  menu: {
    '/apolices': PoliciesPage,
    '/fiancas': BankGuaranteesPage,
    '/comissoes': CommissionsPage,
  },
  moldura: [
    { path: '/apolices/:policyId', element: <PolicyDetailPage /> },
    { path: '/fiancas/:policyId', element: <PolicyDetailPage /> },
  ],
};
